import React from "react";

const AboutMe = ({ lenguaje }) => {
  return (
    <div className="about-me-wraper">
      <h1>{lenguaje == "eng" ? "ABOUT ME" : "ACERCA DE MÍ"}</h1>

      <section className="aboutMe">
        <h2>
          <i class="fas fa-university"></i>
          {lenguaje == "eng"
            ? "I'm a third year Software Engineering student from Temuco, Chile."
            : "Soy un estudiante de tercer año de Ingeniería Civil Informática de Temuco, Chile.  "}
        </h2>

        <h2>
          <i class="fas fa-book"></i>
          {lenguaje == "eng"
            ? "I'm always keen to learn about productivity, math, technologies and more."
            : "Siempre estoy aprendiendo temas de productividad, matemática, tecnologías y otros.  "}
        </h2>
        <h2>
          <i class="fas fa-headphones"></i>
          {lenguaje == "eng"
            ? "On a personal level, I enjoy playing guitar, piano and ride my bike."
            : "A nivel personal disfruto tocar guitarra, piano y andar en bicicleta."}
        </h2>
      </section>
      <div className="languages">
        <h2> {lenguaje == "eng" ? "Languages" : "Lenguajes"}</h2>
        <ul>
          <li>
            {lenguaje == "eng" ? "Spanish" : "Español"}
            <small>{lenguaje == "eng" ? "Native" : "Nativo"}</small>
          </li>
          <li>
            {lenguaje == "eng" ? "English" : "Inglés"}
            <small>{lenguaje == "eng" ? "Fluent" : "Fluido"}</small>
          </li>
          <li>
            {lenguaje == "eng" ? "French" : "Francés"}
            <small>{lenguaje == "eng" ? "Basic" : "Básico"}</small>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AboutMe;
